import { GAMEPLAY_CONFIG } from '@brick-rogue/game-content';
import {
  completeCampaignLevel,
  createInitialCampaignProgress,
  normalizeCampaignProgress,
  selectCampaignLevel,
  type CampaignProgress,
} from '@brick-rogue/game-core';
import { create } from 'zustand';

import { useSaveStore } from '../save/saveStore';

interface CampaignProgressStore extends CampaignProgress {
  readonly hydrate: (progress: CampaignProgress) => void;
  readonly selectLevel: (level: number) => boolean;
  readonly completeLevel: (level: number) => boolean;
}

export const CAMPAIGN_PROGRESS_STORAGE_KEY = 'rogue-brick-breaker:campaign:m1';

const MAX_LEVELS = GAMEPLAY_CONFIG.run.maxWaves;

function selectProgress(state: CampaignProgressStore): CampaignProgress {
  return {
    highestCompletedLevel: state.highestCompletedLevel,
    selectedLevel: state.selectedLevel,
  };
}

export const useCampaignProgressStore = create<CampaignProgressStore>((set, get) => ({
  ...createInitialCampaignProgress(),
  hydrate: (progress) => set(normalizeCampaignProgress(progress, MAX_LEVELS)),
  selectLevel: (level) => {
    const current = selectProgress(get());
    const next = selectCampaignLevel(current, level, MAX_LEVELS);
    if (!Number.isInteger(level) || next.selectedLevel !== level) {
      return false;
    }
    if (next.selectedLevel !== current.selectedLevel) {
      set(next);
      useSaveStore.getState().updateCampaign(next);
    }
    return true;
  },
  completeLevel: (level) => {
    const current = selectProgress(get());
    const next = completeCampaignLevel(current, level, MAX_LEVELS);
    if (next.highestCompletedLevel === current.highestCompletedLevel) {
      return false;
    }
    set(next);
    useSaveStore.getState().updateCampaign(next);
    return true;
  },
}));
